import React from 'react';
import { InvitationStatus, BuyerInfoUser } from '@/types';
import { DateDistanceDisplay } from '@/components/localization';
import { faUserCheck } from '@fortawesome/pro-light-svg-icons';
import { UserIcon } from '@/components/Icons';
import theme from './ResidentialExpandedListItem.module.scss';
import BuyerStatusBadge from './BuyerStatusBadge';
import BuyerContactInfo from './BuyerContactInfo';
import BuyerActions from './BuyerActions';

interface BuyerCardProps {
    buyer: BuyerInfoUser;
    onSendInvite: (buyer: BuyerInfoUser, sendEmail: boolean, sendSms: boolean) => void;
}

const BuyerCard: React.FC<BuyerCardProps> = ({
    buyer,
    onSendInvite,
}) => {
    const getUserDisplayName = (buyer: BuyerInfoUser) => {
        const parts: string[] = [];
        if (buyer.salutation) parts.push(buyer.salutation);
        if (buyer.title) parts.push(buyer.title);
        parts.push(buyer.firstName, buyer.lastName);
        return parts.join(' ');
    };

    return (
        <div className={theme.buyerCard}>
            <div className={theme.buyerAvatar}>
                <UserIcon
                    emptyIcon={buyer.invitedDate && !buyer.acceptedDate ? faUserCheck : undefined}
                    className={theme.userIcon}
                    sizeInPx={60}
                    userId={buyer.userId}
                />
            </div>

            <div className={theme.buyerDetails}>
                <div className={theme.buyerName}>
                    {getUserDisplayName(buyer)}
                </div>

                <div className={theme.buyerStatus}>
                    <BuyerStatusBadge status={buyer.inviteStatus} />
                </div>

                {buyer.inviteStatus === InvitationStatus.Sent && buyer.lastVisitDate && (
                    <div className={theme.lastActivity}>
                        Active: <DateDistanceDisplay value={buyer.lastVisitDate} />
                    </div>
                )}

                <BuyerContactInfo email={buyer.email} phoneNumber={buyer.phoneNumber} />

                <BuyerActions
                    buyer={buyer}
                    onSendInvite={onSendInvite}
                />
            </div>
        </div>
    );
};

export default BuyerCard; 